<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect width="48" height="48" rx="24" fill="#F9F2FF" />
	<path
		d="M36.75 36.75H31.6256V28.7091C31.6256 26.7919 31.5911 24.3232 28.9598 24.3232C26.3285 24.3232 25.882 26.4118 25.882 28.5682V36.7493H20.7575V20.2183H25.677V22.4777H25.7434C26.7465 20.7599 28.6121 19.7339 30.5978 19.8077C35.7919 19.8077 36.75 23.23 36.75 27.6818V36.75ZM14.9749 17.9582C13.3322 17.9582 12.0007 16.6252 12 14.9797C11.9993 13.3344 13.3309 12.0007 14.9736 12C16.6163 12 17.9478 13.3331 17.9485 14.9785C17.9485 16.6245 16.6176 17.9575 14.9749 17.9582ZM17.5372 36.7493H12.4074V20.2183H17.5379L17.5372 36.7493Z"
		stroke="#8F00FF"
		stroke-miterlimit="10"
	/>
</svg>
